import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zkxn3dn2pw: FaireBrandEntity = {
  token: "b_zkxn3dn2pw",
  type: "brand",
  name: "Bee Clean",
  avatarUrl:
    "https://cdn.faire.com/fastly/442a1e63414962ad54c45ef7b8572494606286e3da01059b253a27466d518a2f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/30e9cb5bf0c16a224fc4873a7d1e18622aab53a56755a5d4206c231bcca7da59.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/442a1e63414962ad54c45ef7b8572494606286e3da01059b253a27466d518a2f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/30e9cb5bf0c16a224fc4873a7d1e18622aab53a56755a5d4206c231bcca7da59.jpeg",
  location: "ALBUQUERQUE, NM, USA",
  minimumOrderDollars: 66,
  rating: 5,
  reviewCount: 105,
  isTopShop: true,
  isInsider: true,
  description:
    "At Bee Clean, we set out to create an organic, moisturizing, hassle-free hand sanitizer that would be loved by mother's, children, outdoor enthusiasts, active users and everyone in-between. A few reasons why people love Bee Clean hand sanitizers: - Bee Clean is proudly a New Mexico True Certified product, made in the USA, using 100% organic and natural ingredients. Rather than using sticky goo like other sanitizers, Bee Clean utilizes a spray-on mist that is mess-free and absorbs quickly. Our convenient, innovative, recyclable packaging is pocket-sized, making it easier to take on the go. Despite their small appearance, these bottles can deliver up to 200 uses. Our sanitizer cleans using natural antimicrobial peptides and organic ethyl alcohol to kill 99.9% of germs. Our ingredients include beeswax, vitamin E, avocado oil, and apricot seed oil so hands feel soft and dry with no sticky residue. Beeswax can lock out dryness that is caused by alcohol evaporation. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:47.282Z",
    importedBy: "entity-db-cli",
  },
};
